/// <amd-module name="Repos/Common/Util/Identity" />
import { IdentityRef } from "VSS/Platform/Contracts/WebApi";

/**
 * Strips the [aaaaaa]\ off of group names
 * Doesn't modify individuals
 */
export function getDisplayNameFromIdentity(identity: IdentityRef) {
    if (identity.isContainer) {
        let lastBackSlash = identity.displayName.lastIndexOf("\\");
        if (lastBackSlash < 0) {
            lastBackSlash = identity.displayName.lastIndexOf("/");
        }

        if (lastBackSlash >= 0 && identity.displayName.length > lastBackSlash) {
            return identity.displayName.substring(lastBackSlash + 1);
        }
    }

    return identity.displayName;
}
